import { setAuthToken } from '@/lib/graphql'

const TOKEN_KEY = 'tf_token'

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function saveToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
  setAuthToken(token)
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  setAuthToken(null)
}

// Apply any persisted token to the GraphQL client on boot.
export function bootAuth() {
  const token = getToken()
  if (token) setAuthToken(token)
}
